function fetchGraphQLData(url, query) {
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  const body = JSON.stringify({ query });

  return fetch(url, {
    method: "POST",
    headers: headers,
    body: body,
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      return response.json();
    })
    .catch((error) => {
      throw new Error(`Error in GraphQL query: ${error.message}`);
    });
}

function initTabsAndCarousel() {
  document.querySelectorAll('.home-carousel-container').forEach(container => {
    const nextBtn = container.querySelector('.home-carousel-next');
    const prevBtn = container.querySelector('.home-carousel-prev');
    const carousel = container.querySelector('.home-process-cards-list');

    if (nextBtn && carousel) {
      nextBtn.addEventListener('click', () => {
        carousel.scrollLeft += carousel.offsetWidth;
      });
    }

    if (prevBtn && carousel) {
      prevBtn.addEventListener('click', () => {
        carousel.scrollLeft -= carousel.offsetWidth;
      });
    }
  });

  const tabButtons = document.querySelectorAll('.home-process-tabs div');
  const tabContents = document.querySelectorAll('.home-process-tab-content');

  if (tabButtons.length > 0 && tabContents.length > 0) {
    tabButtons.forEach(button => {
      button.addEventListener('click', () => {
        tabButtons.forEach(btn => {
          btn.classList.remove('active');
          btn.setAttribute('aria-selected', 'false');
        });
        
        button.classList.add('active');
        button.setAttribute('aria-selected', 'true');
        
        tabContents.forEach(content => content.classList.remove('active'));
        
        const tabId = button.getAttribute('data-tab');
        const targetTabContent = document.getElementById(tabId);
        if (targetTabContent) {
          targetTabContent.classList.add('active');
        }
      });
    });
  }
}

function renderParticipatoryProcessTypes(apiData, imageSource = "") {
  if (
    !apiData ||
    !apiData.data ||
    (!apiData.data.participatoryProcessTypes || apiData.data.participatoryProcessTypes.length === 0) &&
    (!apiData.data.assemblies || apiData.data.assemblies.length === 0)
  ) {
    return `
      <div class="page-process-error">
        <span>Nenhum processo encontrado.</span>
      </div>
    `;
  }

  // Define a ordem fixa das 3 primeiras abas
  const orderedTypes = [
    { key: 'conferencias', title: 'Conferência', patterns: [/^conferencia$|^conferência$|^conferencias$|^conferências$/i] },
    { key: 'consultas', title: 'Consulta Pública', patterns: [/^consulta pública$|^consultas públicas$/i] },
    { key: 'planos', title: 'Plano Participativo', patterns: [/^plano$|^planos$|^plano participativo$|^planos participativos$/i] }
  ];

  const now = new Date();
  const assemblies = (apiData.data.assemblies || []).filter(assembly => {
    return assembly.publishedAt && new Date(assembly.publishedAt) <= now;
  });

  // Cria exatamente 3 tipos de processos na ordem correta, sempre
  const processTypes = [];
  
  orderedTypes.forEach((orderedType, index) => {
    let foundType = null;

    // Tenta encontrar o tipo correspondente na API
    if (apiData.data.participatoryProcessTypes && apiData.data.participatoryProcessTypes.length > 0) {
      foundType = apiData.data.participatoryProcessTypes.find(type => {
        const typeTitle = type.title.translation.toLowerCase().trim();
        
        // Exclui audiências
        if (/audiência|audiencia/i.test(typeTitle)) {
          return false;
        }

        // Verifica se corresponde a algum dos padrões deste tipo ordenado
        return orderedType.patterns.some(pattern => pattern.test(typeTitle));
      });
    }

    // Se encontrou na API, usa os dados reais, senão cria mock
    if (foundType) {
      processTypes.push(foundType);
    } else {
      processTypes.push({
        id: `mock-${orderedType.key}`,
        title: { translation: orderedType.title },
        processes: []
      });
    }
  });

  // Debug temporário para verificar quantas abas estão sendo criadas
  console.log('Tipos de processos finais (sempre 3):', processTypes.length, processTypes.map(p => p.title.translation));
  console.log('Assemblies encontrados:', assemblies.length);
  console.log('Total de abas que serão criadas:', processTypes.length + (assemblies.length > 0 ? 1 : 0));

  const cleanImageSource = imageSource.replace(/\/$/, "");
  const defaultImage = "https://brasilparticipativo.presidencia.gov.br/rails/active_storage/representations/redirect/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBM0lXQVE9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--8bafc7018fb30be9c9347f0bc17a9ca1fe1daa6c/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaDdCem9MWm05eWJXRjBTU0lJY0c1bkJqb0dSVlE2RkhKbGMybDZaVjkwYjE5c2FXMXBkRnNITUdrQzZBTT0iLCJleHAiOm51bGwsInB1ciI6InZhcmlhdGlvbiJ9fQ==--64bc4c4a355cc6a5184f6bcffc380675f1050437/de091323edc331be9ff2d0371d76e62414923bd9.png";

  let tabHeadersHTML = `<div class="home-process-tabs" style="margin: 0;" role="tablist">`;
  let tabContentHTML = ``;

  // Define as 4 abas sempre na mesma ordem
  const tabsOrder = [
    'Conferências',
    'Consultas Públicas', 
    'Planos Participativos',
    'Conselhos, Colegiados e Fóruns'
  ];

  // 1. Renderiza as 3 primeiras abas (tipos de processos) sempre na ordem correta
  processTypes.forEach((type, index) => {
    const tabId = `home-tab-${index}`;
    const isFirstTab = index === 0; // Primeira aba sempre ativa
    const activeClass = isFirstTab ? "active" : "";
    
    // Usa o nome da ordem fixa em vez de pluralize_title para garantir consistência
    const tabName = tabsOrder[index];
    const ariaSelected = isFirstTab ? "true" : "false";
    tabHeadersHTML += `<div id="${tabId}-tab" class="${activeClass}" data-tab="${tabId}" role="tab" aria-selected="${ariaSelected}">${tabName}</div>`;

    const validProcesses = type.processes.filter((process) => process);

    const cardsHTML =
      validProcesses.length > 0
        ? validProcesses
            .map((process) => {
              const imageUrl = process.heroImage
                ? `${cleanImageSource}/${process.heroImage.replace(/^\//, "")}`
                : defaultImage;
              const title = process.title.translation;
              const votes = process.votes || 0;
              const comments = process.comments || 0;
              const endDate = new Date(process.endDate);
              const formattedEndDate = endDate.toLocaleDateString("pt-BR", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              });

              const publishedDate = new Date(process.publishedAt);
              const formattedPublishedDate = publishedDate.toLocaleDateString("pt-BR", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
              });

              return `
                <div class="home-process-card">
                  <img src="${imageUrl}" alt="Imagem do processo ${title}">
                  <div class="home-process-card-content">
                    <h3 class="home-process-card-title"><a href="/processes/${process.slug}">${title}</a></h3>
                    <div class="home-process-card-footer">
                      <span class="home-process-tags">${process.hashtag || "sem tags"}</span>
                      <div class="home-process-card-stats">
                        <i class="fa-solid fa-calendar-days"></i>
                        <div class="home-process-date">
                          <div class="home-process-date-title">
                            Início
                          </div>
                          <div class="home-process-date-value">
                            ${formattedPublishedDate}
                          </div>
                        </div>
                        <i class="fa-solid fa-arrow-right"></i>
                        <div class="home-process-date">
                          <div class="home-process-date-title">
                            Encerramento
                          </div>
                          <div class="home-process-date-value">
                            ${formattedEndDate}
                          </div>
                        </div>
                      </div>
                      <a href="/processes/${process.slug}" class="br-button primary assembly-view-button mt-3 mb-3">Visualizar</a>
                    </div>
                  </div>
                </div>
              `;
            })
            .join("\n")
        : `<span class="process-section-error">Nenhum processo encontrado para este tipo.</span>`;

    const activeContentClass = isFirstTab ? "active" : "";
    tabContentHTML += `
      <div id="${tabId}" class="home-process-tab-content ${activeContentClass}" role="tabpanel" aria-labelledby="${tabId}-tab">
        <div class="home-carousel-container">
          <div class="home-carousel-nav">
            <button class="home-carousel-prev" aria-label="Voltar">
              <i class="fa-solid fa-chevron-left"></i>
            </button>
            <button class="home-carousel-next" aria-label="Avançar">
              <i class="fa-solid fa-chevron-right"></i>
            </button>
          </div>
          <div class="home-carousel-wrapper">
            <div class="home-process-cards-list">
              ${cardsHTML}
            </div>
          </div>
        </div>
        <a href="/processes?filter%5Bwith_area%5D=&filter%5Bwith_date%5D=all&filter%5Bwith_scope%5D=&filter%5Bwith_type%5D=${type.id}" class="br-button primary" style="width: fit-content; align-self: center;">Ver mais</a>
      </div>
    `;
  });

  // 2. Sempre renderiza a 4ª aba (Conselhos, Colegiados e Fóruns)
  const assembliesTabId = `home-tab-assemblies`;
  
  // Usa o nome fixo da ordem definida
  tabHeadersHTML += `<div id="${assembliesTabId}-tab" data-tab="${assembliesTabId}" role="tab" aria-selected="false">${tabsOrder[3]}</div>`;

  const assembliesCardsHTML = assemblies.length > 0 
    ? assemblies
        .map((assembly) => {
          if(assembly.parent !== null) {
            return;
          }

          const imageUrl = assembly.heroImage
            ? `${cleanImageSource}/${assembly.heroImage.replace(/^\//, "")}`
            : defaultImage;

          const title = assembly.title.translation;

          return `
            <div class="home-process-card">
              <img src="${imageUrl}" alt="Imagem do conselho ${title}">
              <div class="home-process-card-content">
                <h3 class="home-process-card-title"><a href="/assemblies/${assembly.slug}">${title}</a></h3>
                <div class="home-process-card-footer">
                  <span class="home-process-tags">${assembly.hashtag || "sem tags"}</span>
                  <a href="/assemblies/${assembly.slug}" class="br-button primary assembly-view-button">Visualizar</a>
                </div>
              </div>
            </div>
          `;
        })
        .join("\n")
    : `<span class="process-section-error">Nenhum conselho encontrado.</span>`;

  tabContentHTML += `
    <div id="${assembliesTabId}" class="home-process-tab-content" role="tabpanel" aria-labelledby="${assembliesTabId}-tab">
      <div class="home-carousel-container">
        <div class="home-carousel-nav">
          <button class="home-carousel-prev" aria-label="Voltar">
            <i class="fa-solid fa-chevron-left"></i>
          </button>
          <button class="home-carousel-next" aria-label="Avançar">
            <i class="fa-solid fa-chevron-right"></i>
          </button>
        </div>
        <div class="home-carousel-wrapper">
          <div class="home-process-cards-list">
            ${assembliesCardsHTML}
          </div>
        </div>
      </div>
      <a href="/assemblies" class="br-button primary" style="width: fit-content; align-self: center;">Ver mais</a>
    </div>
  `;

  tabHeadersHTML += `</div>`;

  console.log('Total de abas criadas: 4 (fixo)');

  return `
    <div class="home-processes">
      ${tabHeadersHTML}
      ${tabContentHTML}
    </div>
  `;
}

function manageParticipatoryProcesses(apiUrl, imageSource = "") {
  const container = document.querySelector("#participatory-process-section");
  if (!container) {
    console.error('Elemento com id "participatory-process-section" não encontrado.');
    return;
  }

  const processesContainer = container.querySelector(".home-processes");
  if (!processesContainer) {
    console.error('Elemento com classe "home-processes" não encontrado.');
    return;
  }

  processesContainer.innerHTML = `
    <div class="page-process-error">
      <span class="process-loading">Carregando...</span>
    </div>
  `;

  const query = `
    query {
      participatoryProcessTypes {
        id
        title {
          translation(locale: "pt-BR")
        }
        processes {
          id
          slug
          publishedAt
          title {
            translation(locale: "pt-BR")
          }
          heroImage
          hashtag
          votes
          comments
          endDate
        }
      }
      assemblies {
        id
        slug
        title {
          translation(locale: "pt-BR")
        }
        heroImage
        hashtag
        publishedAt
        parent {
          id
        }
      }
    }
  `;

  fetchGraphQLData(apiUrl, query)
    .then((apiData) => {
      const renderedHTML = renderParticipatoryProcessTypes(apiData, imageSource);
      processesContainer.innerHTML = renderedHTML;
      initTabsAndCarousel();
    })
    .catch((error) => {
      console.error("Erro:", error);
      processesContainer.innerHTML = `
        <div class="page-process-error">
          <span>Erro ao buscar processos.</span>
        </div>
      `;
    });
}

function pluralize_title(title) {
  let pluralized_title = title;

  switch (pluralized_title) {
    case "Consulta Pública":
      pluralized_title = "Consultas Públicas";
      break;
    case "Conferência":
      pluralized_title = "Conferências";
      break;
    case "Plano":
      pluralized_title = "Planos Participativos";
      break;
    case "Plano Participativo":
      pluralized_title = "Planos Participativos";
      break;
  }

  return pluralized_title;
}

window.manageParticipatoryProcesses = {
  manageParticipatoryProcesses: manageParticipatoryProcesses,
};
